import { render, staticRenderFns } from "./HeadComponent.vue?vue&type=template&id=33a20e50&scoped=true&"
import script from "./HeadComponent.vue?vue&type=script&lang=js&"
export * from "./HeadComponent.vue?vue&type=script&lang=js&"
import style0 from "./HeadComponent.vue?vue&type=style&index=0&id=33a20e50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a20e50",
  null
  
)

export default component.exports